<template>
  <div id="printme">
    <table style="width: 100%; background: rgb(228, 229, 230);">
      <tbody>
        <tr>
          <td>
            <div class="card-body page-break">
              <div id="printme" class="col-sm-12">
                <div class="row">
                  <div class="col-sm-12">
                    <img src="/assets/img/logo.jpg" alt="" width="200px">
                    <h4 class="text-center border" style="background-color: #f3f3f2; padding: 10px 0;margin-bottom:0;border-bottom:0!important;flex:1">
                      <div class="d-flex">
                        <span style="flex: 1;">Nota de Reembolso de Despesas</span>
                        <span style="padding-right: 10px;">{{ refundNote.refund.code }}</span>
                      </div>
                    </h4>
                    <table class="table border lead" style="padding: 10px 0">
                      <tbody v-if="refundNote.refund.employee">
                        <tr>
                          <th style="width:75px">Funcionário:</th>
                          <td>{{ refundNote.refund.employee }}</td>
                        </tr>
                        <tr>
                          <th style="width:75px" v-if="refundNote.refund.cnpj">CNPJ:</th>
                          <th v-else>CPF:</th>
                          <td>
                            <span v-if="refundNote.refund.cnpj">{{ refundNote.refund.cnpj | VMask('##.###.###/####-##') }}</span>
                            <span v-else>
                              <span v-if="refundNote.refund.cpf">{{ refundNote.refund.cpf | VMask('###.###.###-##') }}</span>
                              <span v-else>---</span>
                            </span>
                          </td>
                        </tr>
                        <tr>
                          <th style="width:75px">Vencimento:</th>
                          <td v-if="refundNote.refund.expiration_date">{{ refundNote.refund.expiration_date | formatDate }}</td>
                          <td v-else>---</td>
                        </tr>
                      </tbody>
                    </table>
                    <table class="table table-bordered table-striped lead">
                      <thead>
                        <tr>
                          <th>#</th>
                          <th>Data</th>
                          <th>Tipo</th>
                          <th>Descrição</th>
                          <th class="text-right">Valor</th>
                        </tr>
                      </thead>
                      <tbody v-if="refundNote">
                        <tr v-for="(refund, itemIdx) in refundNote.data" :key="refund.items[0].pk">
                          <td>{{ itemIdx + 1 }}</td>
                          <td>{{ refund.items[0].repayment_date | formatDate }}</td>
                          <td>{{ refund.items[0].type_expense.text }}</td>
                          <td>{{ refund.items[0].description }}</td>
                          <td>R$ <span class="pull-right">{{ refund.items[0].value | formatPrice }}</span></td>
                        </tr>
                      </tbody>
                      <tfoot>
                        <tr>
                          <th class="text-right" colspan="4">Valor Total</th>
                          <th style="width:150px">R$ <span class="pull-right">{{ refundNote.refund.total | formatPrice }}</span></th>
                        </tr>
                      </tfoot>
                    </table>
                  </div>
                </div>
                <div class="border lead" style="padding:15px 0 0 10px;line-height:.5em;">
                  <p>Dados para depósito</p>
                  <p>Pinheiro e Sandi Sociedade de Advogados</p>
                  <p>CNPJ: 30.589.909/0001-98</p>
                  <p>Banco Itaú 341</p>
                  <p>Agência 8474</p>
                  <p>Conta 19.687-3</p>
                </div>
              </div>
            </div>
            <div v-if="refundNote">
              <div class="page-break" v-for="refund in refundNote.data" :key="refund.items[0].pk">
                <div style="background: rgb(228, 229, 230); width: 100%; height: 100%; position: absolute;"></div>
                <div style="padding-top: 10px;">
                  <div class="card">
                    <div class="card-body" style="margin: 30px;">
                      <p>{{ refund.items[0].description }}</p>
                      <img :src="refund.items[0].doc_jpg.url" v-if="refund.items[0].doc_jpg && refund.items[0].doc_jpg.url" width="50%" height="auto">
                      <p class="lead" v-else>Sem anexo.</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="text-center lead page-footer" style="padding-top:20px;line-height:1em">
              <p>Rua Joaquim Floriano, 72, conj. 175 - Itaim Bibi - São Paulo - SP - Brasil F: 11 2528-1044</p>
              <p>www.pgsa.com.br</p>
            </div>
          </td>
        </tr>
      </tbody>
      <tfoot>
        <tr>
          <td>
            <div class="page-footer-space"></div>
          </td>
        </tr>
      </tfoot>
    </table>
  </div>
</template>
<script>
import axios from 'axios';

export default {
  data() {
    return {
      isVisible: false,
      refundNote: {
        refund: {}
      }
    };
  },
  mounted() {
    axios.get('/financial/expense-note/' + this.$route.params.pk)
      .then(res => {
        this.refundNote = res.data;

        document.title = res.data.refund.code;

        setTimeout(() => {
          const images = res.data.data
            .filter(i => i.items[0] && i.items[0].doc_jpg && i.items[0].doc_jpg.url)
            .map(i => i.items[0].doc_jpg.url);

          let loadedImages = 0;

          if (images.length == 0) {
            const newParent = document.querySelector('.app');
            const main = document.querySelector('main');

            newParent.appendChild(main);

            setTimeout(() => {
              window.print();

              setTimeout(() => {
                window.close();
              }, 500);
            }, 250);
          }

          images.forEach(image => {
            const img = new Image();
            img.src = image;

            img.onload = function() {
              loadedImages++;

              if (loadedImages == images.length) {
                const newParent = document.querySelector('.app');
                const main = document.querySelector('main');

                newParent.appendChild(main);

                setTimeout(() => {
                  window.print();

                  setTimeout(() => {
                    window.close();
                  }, 500);
                }, 500);
              }
            }
          })
        }, 500);
      });
  },
}
</script>
<style>
* {
  -ms-overflow-style: none;
  /* IE and Edge */
  scrollbar-width: none;
  /* Firefox */
}

*::-webkit-scrollbar {
  display: none;
}

#printme {
  padding-top: 15px;
}

.app-body {
  margin-top: 0px !important;
}

.container-fluid {
  padding: 0px !important;
}

#printme img {
  margin-bottom: 10px;
}

.app-header,
.breadcrumb,
.sidebar,
.app-footer {
  display: none;
}

.main {
  margin-left: 0px !important;
}

@page {
  size: A4;
  margin: 11mm 17mm 10mm 17mm;
}

/* Styles go here */
.page-footer {
  height: 90px;
}

.page-footer {
  position: fixed;
  bottom: 0;
  width: 100%;
  border-top: 1px solid black;
  text-align: center;
  z-index: 1;
}

.page-break {
  page-break-before: always;
  page-break-inside: avoid;
  width: 100%;
  height: 100%;
}

.card {
  margin: 30px;
}

@media print {
  tfoot {
    display: table-footer-group;
  }
}

</style>
